import I18n from 'I18n';
export const isContentTab = value => value === 'all' || value === 'completed' || value === 'incomplete';
export const getContentStatus = tab => isContentTab(tab) ? tab === 'all' ? undefined : tab.toUpperCase() : undefined;
const CONTENT_TYPE_I18N_KEYS = {
  TRACK: 'academyCommon.contentTypes.TRACK',
  LESSON: 'academyCommon.contentTypes.LESSON',
  SHORT_FORM_CONTENT: 'academyCommon.contentTypes.SHORT_FORM_CONTENT',
  PLAYLIST: 'academyCommon.contentTypes.PLAYLIST',
  LEARNING_PATH: 'academyCommon.contentTypes.HUBSPOT_PLAYLIST'
};
export const getContentTypeLabel = contentType => {
  const key = CONTENT_TYPE_I18N_KEYS[contentType];
  return key ? I18n.text(key) : contentType;
};